module.exports = __webpack_public_path__ + "static/bo-jackson-2311b878f53779b06905aa9b46813010.jpeg";